module.exports = __webpack_public_path__ + "img/gy.79fcf270.svg";